import { render, staticRenderFns } from "./SubscriptionAnnualDiscount.vue?vue&type=template&id=5586bfe1&scoped=true"
import script from "./SubscriptionAnnualDiscount.vue?vue&type=script&lang=js"
export * from "./SubscriptionAnnualDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586bfe1",
  null
  
)

export default component.exports